import { sample } from "effector"
import { isEmpty } from "ramda"
import { t } from "i18next"
import { notificationsApi, windowApi } from "@callcenter/api"
import { $themeService } from "@callcenter/effector-services"

import { userAccountApi } from "../api"
import { userAccountModel } from "./user-account"

sample({
  clock: userAccountApi.userProfileSaveFx.failData,
  source: { isCustomTheme: $themeService.$isCustomThemeSettingsAvailable, formValue: userAccountModel.$formValue },
  filter: ({ isCustomTheme, formValue }, failResponse) =>
    !isEmpty(failResponse) && !isCustomTheme && isEmpty(formValue.current_password),
  fn: () => ({ text: t("userProfile_notification_notificationLabel_accountSettingsErrorLabel") }),
  target: notificationsApi.failedNotificationFx
})

sample({
  clock: userAccountApi.userProfileSaveFx.doneData,
  target: windowApi.reloadFx
})
